module.exports = __webpack_public_path__ + "static/autonomy-0d16555436ec71395a3e42d5388c616f.png";